import { useEffect } from "react";

export const SITE = "https://jobpedestal.com";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function useSeo({ title, description, path, jsonLd }) {
  useEffect(() => {
    const full = `${title} | JobPedestal`;
    const url = `${SITE}${path}`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
    document.head.querySelectorAll("script[data-seo-jsonld]").forEach((s) => s.remove());
    (jsonLd || []).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "1");
      s.text = JSON.stringify({ "@context": "https://schema.org", ...obj });
      document.head.appendChild(s);
    });
  }, [title, description, path, jsonLd]);
}

export const ORG_LD = { "@type": "Organization", name: "JobPedestal", url: SITE, logo: `${SITE}/logo512.png`, email: "contactus@jobpedestal.com" };
export const crumbs = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE}${path}` })),
});
